export default __webpack_public_path__ + "static/media/GoodMannersWithYourFriends_08.8062cb21.png";